<template>
  <div class="sidebar" v-if="!$route.meta.sidebar">
    <el-menu class="sidebar-el-menu" :default-active="onRoutes" background-color="#3A3F51" text-color="#ffffff"
      :collapse="collapse" active-text-color="#ffffff" unique-opened router @select="selectChange">
      <template v-for="item in items">
        <template v-if="item.subs">
          <el-submenu :index="item.index" :key="item.index" v-if="item.show">
            <template slot="title">
              <i :class="item.icon" class="iconfont"></i><span slot="title">{{ item.title }}</span>
            </template>
            <template v-for="(subItem, i) in item.subs">
              <template v-if="subItem.subs">
                <el-submenu :index="subItem.index" :key="i" v-if="subItem.show">
                  <template slot="title">
                    <i :class="subItem.icon" class="iconfont"></i><span slot="title">{{ subItem.title }}</span>
                  </template>
                  <template v-for="(hhhItem, j) in subItem.subs">
                    <el-menu-item :key="j" :index="hhhItem.index" v-if="hhhItem.show">
                      <i :class="hhhItem.icon" class="iconfont"></i><span slot="title">{{ hhhItem.title }}</span>
                    </el-menu-item>
                  </template>
                </el-submenu>
              </template>
              <template v-else>
                <el-menu-item :key="i" :index="subItem.index" v-if="subItem.show">
                  <i :class="subItem.icon" class="iconfont"></i><span slot="title">{{ subItem.title }}</span>
                </el-menu-item>
              </template>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index" :key="item.index" v-if="item.show">
            <i :class="item.icon" class="iconfont"></i><span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>
<script>
import bus from "./bus";
import GlobalUtil from "@/utils/globalUtil";
export default {
  data() {
    return {
      collapse: false,
      items: [],
      home: [{
        icon: "iconDguanwang",
        index: "businessManagementIndex",
        show: true,
        title: "3D官网"
      },
      {
        icon: "iconDshangcheng",
        index: "3",
        show: true,
        title: "3D商城",
        subs: [{
          index: "3dshoppingcategory",
          show: true,
          title: "类目管理"
        },
        {
          index: "3dshoppinggoodMessage",
          show: true,
          title: "商品管理"
        },
        ]
      },
      {
        icon: "iconqiyeguanli",
        index: "34",
        show: true,
        title: "企业管理",
        subs: [{
          index: "3dbussinesspermissions",
          show: true,
          title: "组织架构"
        },
        {
          index: "3dbussinesspeopleGL",
          show: true,
          title: "员工管理"
        },
        ]
      },
      {
        icon: "icondingdanguanli",
        index: "31",
        show: true,
        title: "订单管理",
        subs: [{
          index: "dingdanoverview",
          show: true,
          title: "订单概览"
        },
        {
          index: "dingdanindentList",
          show: true,
          title: "订单列表"
        },
        ]
      },
      {
        icon: "iconshujukanban",
        index: "36",
        show: true,
        title: "数据看板",
        subs: [{
          index: "databoardflowStatistics",
          show: true,
          title: "流量统计"
        },
        {
          index: "databoardstaffStatistics",
          show: true,
          title: "员工统计"
        },
        {
          index: "databoardsalesStatistics",
          show: true,
          title: "销量统计"
        },
        ]
      },
      {
        icon: "iconzhanghaoguanli",
        index: "accountindex",
        show: true,
        title: "帐号设置"
      },
      ]
    };
  },
  computed: {
    onRoutes() {
      this.items = this.items.map((_, index) => {
        if (_.index.includes(this.$route.path.split("/")[2])) {
          _.iconShow = false;
        } else {
          _.iconShow = true;
        }
        return _;
      });
      return this.$route.path.split("/")[2];
    }
  },
  created() {
    this.ifchatChannel()
    let actRoute = this.$route.path.split("/")[1];
    if (actRoute === "home") {
      this.items = this.home;
    }
    // this.getPermission()
    // 通过 Event Bus 进行组件间通信，来折叠侧边栏
    bus.$on("collapse", msg => {
      this.collapse = msg;
    });
  },
  methods: {
    selectChange(data) {
      console.log(data);
      this.$router.push({
        name: data
      });
    },
    ifchatChannel() {
      const entCode = localStorage.getItem('entCode');
      if ("240823155506000010" == entCode) {
        this.home.push({
          icon: "iconzhanghaoguanli",
          index: "chatChannel",
          show: true,
          title: "视频号"
        })
      }
    },
    compare(name, minor) {
      return function (o, p) {
        var a, b;
        if (o && p && typeof o === "object" && typeof p === "object") {
          a = o[name];
          b = p[name];
          if (a === b) {
            return typeof minor === "function" ? minor(o, p) : 0;
          }
          if (typeof a === typeof b) {
            return a < b ? -1 : 1;
          }
          return typeof a < typeof b ? -1 : 1;
        } else {
          // thro('error')
        }
      };
    },
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        let actRoute = this.$route.path.split("/")[1];
        if (actRoute.includes("home")) {
          this.items = this.home;
        }
      },
      // 深度观察监听
      deep: true
    }
  }
};

</script>
<style scoped>
.sidebar-logo {
  height: 88px;
  line-height: 88px;
  margin-left: 32px;
  font-size: 18px;
  color: #a1a7dbff;
}

.sidebar {
  display: block;
  width: 256px;
}

.iconfont {
  padding-right: 7px;
}

.sidebar::-webkit-scrollbar {
  width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
  width: 256px;
}

.sidebar>ul {
  height: 100%;
}

.el-menu-item.is-active {
  background-color: #59cce1 !important;
  color: #fff !important;
}

.el-menu-item.is-active i {
  color: inherit !important;
}

.el-menu-item i {
  color: #ffffff;
}

.el-menu--inline li {
  background-color: #1f2228 !important;

}

.el-menu-item {
  height: 50px;
  line-height: 50px;
}
</style>
<style lang="less" scoped>
.sidebar .el-submenu__title {
  color: #ffffff;
  line-height: 48px;
  height: 48px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(176, 178, 185, 1);
  /* text-align: center; */
}

.el-menu--inline li {
  background-color: #1f2228 !important;

  .iconfont {
    padding: 1px;
  }
}

.sidebar .el-submenu__title i {
  color: #ffffff;
}

.sidebar .el-submenu .el-menu-item {
  line-height: 39px;
  height: 50px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}

.sidebar .el-submenu .el-menu-item:hover {
  background: #59cce1 !important;
}

.sidebar-el-menu,
.el-menu,
.sidebar {
  background: #000;
}

.el-menu-item {
  background-color: transparent !important;
  color: rgba(225, 225, 225, 1) !important;
}

.is-active {
  position: relative;
  background: #59cce1;
}

img {
  width: 21px;
  height: 17px;
  margin-right: 29px;
  margin-left: 12px;
}

span {
  font-size: 14px;
}

// .is-active::before {
//   position: absolute;
//   left: 0;
//   display: block;
//   content: "";
//   width: 264px;
//   width: 3px;
//   height: 100%;
//   background: linear-gradient(180deg,
//       rgba(253, 213, 115, 1) 0%,
//       rgba(251, 181, 96, 1) 100%);
//   border-radius: 1px 3px 3px 1px;
// }</style>
